module.exports = __webpack_public_path__ + "img/195-france.823dd4b3.svg";